import { render, staticRenderFns } from "./pictureQuestion.vue?vue&type=template&id=1dcb77db&scoped=true&"
import script from "./pictureQuestion.vue?vue&type=script&lang=js&"
export * from "./pictureQuestion.vue?vue&type=script&lang=js&"
import style0 from "./pictureQuestion.vue?vue&type=style&index=0&id=1dcb77db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcb77db",
  null
  
)

export default component.exports